const layout = {
    namespaced: true,
    state: {
        menu: {
            isOpen: false,
            hoverActive: false,
        },
        zoom: 100,
    },
    mutations: {
        TOGGLE_MENU: (state, close) => {
            state.menu.isOpen = typeof close === "boolean" ? close : !state.menu.isOpen;
        },
        TOGGLE_HOVER_MENU: (state, close) => {
            state.menu.hoverActive = typeof close === "boolean" ? close : !state.menu.hoverActive;
        },
        CHANGE_ZOOM: (state, zoom) => {
            state.zoom = zoom;
        },
    },
    actions: {
        toggleMenu({ commit }, close) {
            commit("TOGGLE_MENU", close);
        },
        toggleHoverMenu({ commit }, close) {
            commit("TOGGLE_HOVER_MENU", close);
        },
        changeZoom({ commit }, zoomValue) {
            commit("CHANGE_ZOOM", zoomValue);
        },
    },
};

export default layout;
